export default "__VITE_ASSET__DhfOuq_L__"